import { Button, Grid, LinearProgress, Typography } from '@material-ui/core'
import React from 'react'
import { ReportTeamTable } from './ReportTeamTable'
import { useHistory } from 'react-router-dom';
import { useReportTeamData } from '../../../common/CommonQueries';
import ScreenWidth from '../../../common/ScreenWidth';



export const ReportTeamView = () => {


    const history = useHistory();
    const widthCurrent = ScreenWidth();



    const {
        data:ReportTeamData,
        error:errorReportTeamData,
        isLoading:isLoadingReportTeamData,
        isError: isErrorReportTeamData
    } = useReportTeamData()


    if(isLoadingReportTeamData){
        return <LinearProgress />
    }

    return (

        <>
            <div style={{ margin: 10, padding: 10 }}>
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={2}
                >
                    <Grid item>
                        <Typography variant="h2">Report Team</Typography>
                    </Grid>

                    <Grid item>
                        <Button variant="contained" color="primary" style={{ marginRight: "100px" }}
                            onClick={() =>
                                history.push(
                                    `/reports/report_team/add_report_team`
                                )
                            }
                        >
                            Add New Report Team
                        </Button>
                    </Grid>
                </Grid>
            </div>

            {ReportTeamData && <ReportTeamTable data={ReportTeamData} />}
        </>

    )
}


